// extracted by mini-css-extract-plugin
export default {"pageLoad":"LoadingSplashScreen_pageLoad__yhYvF","componentLoad":"LoadingSplashScreen_componentLoad__PbENs"};